import { useInfiniteQuery } from 'react-query';

import { columnDefinitionKey } from 'Modules/ActionsRewrite_2024/components/columnDefs/keysToColumnDefinitions';
import { getActions } from '@groove/api/gateway/v1/actions';

export const useGetActionsInfinitely = (
  sortedColumnKeys: columnDefinitionKey[]
) =>
  useInfiniteQuery(
    ['getActionsInfinitely', ...sortedColumnKeys],
    ({ pageParam = 1 }) => getActions({ page: pageParam, per_page: 30 }),
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.length > 0) {
          return allPages.length + 1;
        }
        return undefined; // TODO: block the fetch when next param is undefined
      },
    }
  );
